import { getLayoutData, getPageData, getPages } from "../api/api"
import { FRAGMENTS } from "@repo/ui/lib"
import { DESIGN_FRAGMENTS } from "@/lib"
import { getPropSafely } from "@repo/utils"
import ExtendedContent from "@/components/common/ExtendedContent"
import dynamic from "next/dynamic"
import JobOfferBanner from "@repo/ui/src/components/Banners/JobOfferBanner"

const StickyHeading = dynamic(() => import("@repo/ui/src/components/StickyHeading"), {
	ssr: false,
})

export default function Page({ data }) {
	const bannerData = {
		header: data?.bannerHeader || "",
		tag: data?.bannerTag || "",
		goBackButtonText: data?.goBackButtonText || "",
		jobDescription: data?.jobDescription || "",
	}

	console.log(data)
	const contentData = getPropSafely(data, "content", [])
	const stickyHeadingsSelectors = getPropSafely(data, "stickyHeadingsSelector", [])

	return (
		<>
			<StickyHeading stickyHeadingsSelectors={stickyHeadingsSelectors} />
			<JobOfferBanner data={bannerData} />
			<ExtendedContent content={contentData} />
		</>
	)
}

const pathsQuery = `
	query GetJoOffersPageData($locale: SiteLocale) {
		allCommonJobOfferPages(locale: $locale, filter: {slug: {neq: "home"}}) {
            name
            slug
		}
	}
`

const propsQuery = `
	query GetSingleJobOfferPage($slug: String, $locale: SiteLocale)  {
		allCommonJobOfferPages(locale: $locale, filter: {slug: {eq: $slug}}) {
			name
			slug
			${FRAGMENTS.SEO_META_FRAGMENT}
			goBackButtonText
            bannerHeader
            bannerTag
            jobDescription
            
            ${DESIGN_FRAGMENTS.STICKY_HEADING_FRAGMENT}
            
            content {
                __typename
                ${FRAGMENTS.TEXT_MODULE_FRAGMENT}
                ${FRAGMENTS.JOB_OFFER_FORM_MODULE_FRAGMENT}
                ${FRAGMENTS.CARRER_MODULE_FRAGMENT}
            }
		}
	}
`

export async function getStaticProps({ params, locale }) {
	const { slug } = params
	const data = await getPageData("allCommonJobOfferPages", slug, propsQuery, locale)
	const { globals, cookies, menu, footer } = await getLayoutData(locale)
	return {
		props: {
			data,
			globals,
			cookies,
			locale,
			menu,
			footer,
		},
		revalidate: 120,
	}
}

export async function getStaticPaths({ locales }) {
	const paths = []
	for (const locale of locales) {
		const projectPosts = await getPages("allCommonJobOfferPages", pathsQuery, locale)
		const posts = projectPosts.map((page) => ({
			params: {
				slug: page.slug,
			},
			locale,
		}))
		paths.push(...posts)
	}
	// { fallback: false } means other routes should 404.
	return {
		paths,
		fallback: false,
	}
}
